import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile} from "../../../helpers/utils/FileUtils";

export const countiesApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getAllCountyByStateAbbr: build.query({
            query: (stateAbbreviation) => {
                return {
                    url: `/ajax/county-by-state/${stateAbbreviation}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags:["getAllCountyByStateAbbr"],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getAllCountyByStateId: build.query({
            query: (stateId) => {
                return {
                    url: `/ajax/county-by-state-id/${stateId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getRecipientByCountyId: build.query({
            query: ({countyId, tenantId}) => {
                return {
                    url: `/counties/${countyId}/recipient?tenantId=${tenantId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        searchCounties: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/counties?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['counties'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createCounty: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/submitCounty`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['counties'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Created","County")
            },
        }),
        getCountyById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-county-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['countyById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getCountiesByStateIds: build.query({
            query: (stateIds) => {
                let list = {stateIds:stateIds}
                let paramData = serialize(list)
                return {
                    url: `/ajax/counties-by-state-ids?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['countiesByStateIds'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        updateCounty: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-county-by-id/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['counties', 'countyById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","County")
            },
        }),

        exportCountyData: build.query({
            query: (query) => {
                return {
                    url: `/export/county`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("counties"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),
});


export const {
    useGetAllCountyByStateAbbrQuery,
    useGetAllCountyByStateIdQuery,
    useLazyGetAllCountyByStateIdQuery,
    useGetRecipientByCountyIdQuery,
    useCreateCountyMutation,
    useGetCountyByIdQuery,
    useLazyGetCountyByIdQuery,
    useUpdateCountyMutation,
    useSearchCountiesQuery,
    useLazyExportCountyDataQuery,
    useLazyGetAllCountyByStateAbbrQuery,
    useGetCountiesByStateIdsQuery,
    useLazyGetCountiesByStateIdsQuery
} = countiesApi;